import { Injectable }                   from '@angular/core';
import { Title }                        from '@angular/platform-browser';
import { Router }                       from '@angular/router';
import { AnalyticsDataProviderService } from '@core/analytics/analytics-data-provider.service';
import { MatomoTracker }                from 'ngx-matomo-client';

// import { MatomoTracker }                from '@ngx-matomo/tracker';

@Injectable( { providedIn: 'root' } )
export class AnalyticsMatomoService {

	private _isUserConsent: boolean = true;  // user consent for the future cookie bar usage
	private _uuidRegexPattern: RegExp = new RegExp( '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}', 'ig' );
	private _uuidReplacement: string = '{uuid}';

	constructor(
		private _analyticsDataProviderService: AnalyticsDataProviderService,
		private readonly _matomoTracker: MatomoTracker,
		private readonly _router: Router,
		private readonly _titleService: Title
	) {
		this.localInit();
	}

	private localInit() {
		// user consent
		// if ( !this._isUserConsent ) {
		// 	this._matomoTracker.forgetConsentGiven();
		// } else {
		// 	this._matomoTracker.setConsentGiven();
		// }
	}

	/**
	 * Track after a router event when actual url and page title is available. Resolves feature flag.
	 */
	trackAfterRouterEvent(): void {
		// FF
		if ( this._analyticsDataProviderService?.analyticsDataConfig?.featureEnabled ) {
			const url: string = this._router?.routerState?.snapshot?.url;
			const pageTitle: string = this._titleService.getTitle();
			const anonUrl = this.anonymizeUUIDs( url );
			this.trackAll( anonUrl, pageTitle );
		}
	}

	private trackAll( url: string, name: string ): void {
		this._matomoTracker.setCustomUrl( url );

		this._matomoTracker.trackPageView( name );

		// EVENTS
		// user info
		this._matomoTracker.trackEvent( 'isSupportAdmin', this._analyticsDataProviderService?.hasSupportRole().toString() );

		// other provided info
		this._matomoTracker.trackEvent( 'dpi', this._analyticsDataProviderService?.getDpi() );
		this._matomoTracker.trackEvent( 'deviceOrientation', this._analyticsDataProviderService?.getDeviceOrientation() );
		this._matomoTracker.trackEvent( 'isTouchDevice', this._analyticsDataProviderService?.getIsTouchDevice() + '' );
		this._matomoTracker.trackEvent( 'zoomLevel', this._analyticsDataProviderService?.getZoomLevel()?.toString() );
		// this._matomoTracker.trackEvent( 'windowResolution', this._analyticsDataProviderService?.getWindowResolution() );
	}

	/**
	 * Anonymize any UUID which is found in passed string.
	 *
	 * @param url string with or without UUIDs, don't modify this original string
	 * @return new string with replaced UUIDs
	 */
	private anonymizeUUIDs( url: string ): string {
		const uuidRegexPattern: RegExp = this._uuidRegexPattern;

		url.match( uuidRegexPattern )?.forEach( ( uuid: string ) => {
				url = url.replace( uuid, this._uuidReplacement );
			}
		);

		return url;
	}

}
